/* eslint-disable prettier/prettier */
// Import gsap
import { gsap } from "gsap";

export default class AnimateBlock {    

    static animateBlock = (function() {
       // ANIMATE IMAGE  
        gsap.fromTo('.animateBlock', {
            y: 50,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            duration: 2,
            ease: "power2.out",
        });
    });    

   
    static init(){
        let media = gsap.matchMedia();
        media.add("(min-width: 981px)", () => {
            AnimateBlock.animateBlock();
        })
        
    }    
    
}


